import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DtoGroupCategoryWithProductVM } from '../../../Model/orders/DtoGroupCategoryWithProductVM';
import { DtoProductsVM } from '../../../Model/price-list/DtoProductsVM';

@Component({
  selector: 'app-order-nav-item',
  templateUrl: './order-nav-item.component.html',
  styleUrl: './order-nav-item.component.scss'
})
export class OrderNavItemComponent {
  @Input() item: DtoGroupCategoryWithProductVM | any;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() newItemEvent = new EventEmitter<DtoProductsVM[]>();
  @Output() showProduct = new EventEmitter<boolean>();

  isExpanded: boolean = true;
  showSubmenu: boolean = true;
  ProductsList: DtoProductsVM[] = [];
  selectedCategoryId?: number = 0;
  constructor() { }

  ShowProducts(id?: number) {
    this.selectedCategoryId = id;
    this.ProductsList = [];
    var listCategory = this.item.listCategory.filter((a: any) => a.id == id);
    listCategory.map((p: any) => {
      p.products.forEach((element: DtoProductsVM) => {
        this.ProductsList.push(element);
      });
    });

    this.newItemEvent.emit(this.ProductsList);
  }

  onItemSelected(item: DtoGroupCategoryWithProductVM) {
    if (item.listCategory && item.listCategory.length) {
      this.isExpanded = !this.isExpanded;
    }

    //scroll
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    if (!this.isExpanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }
}
